// Status badge classes using UX brief color tokens
export const rentalStatusConfig = {
  pending:   { label: 'Pending',   bg: 'bg-amber-50',  text: 'text-amber-800',  border: 'border-amber-300', icon: 'clock' },
  active:    { label: 'Active',    bg: 'bg-blue-50',   text: 'text-blue-800',   border: 'border-blue-300',  icon: null },
  overdue:   { label: 'Overdue',   bg: 'bg-red-100',   text: 'text-red-800',    border: 'border-red-400',   icon: 'exclamation' },
  returned:  { label: 'Returned',  bg: 'bg-green-50',  text: 'text-green-800',  border: 'border-green-300', icon: 'check' },
  cancelled: { label: 'Cancelled', bg: 'bg-gray-100',  text: 'text-gray-500',   border: 'border-gray-300',  icon: null },
}

export const vehicleStatusConfig = {
  available:   { label: 'Available',   dot: 'bg-green-500',  text: 'text-green-800' },
  rented:      { label: 'Rented',      dot: 'bg-blue-500',   text: 'text-blue-800'  },
  maintenance: { label: 'Maintenance', dot: 'bg-amber-500',  text: 'text-amber-800' },
  retired:     { label: 'Retired',     dot: 'bg-gray-400',   text: 'text-gray-500'  },
}

// Backward-compat: flat "bg text" string map (used by older pages)
export const rentalStatusColors = Object.fromEntries(
  Object.entries(rentalStatusConfig).map(([k, v]) => [k, `${v.bg} ${v.text}`])
)

// Backward-compat: dashboard colors (hex values expected by Home/Index chart legend)
export const dashboardStatusColors = {
  pending:   { bg: '#FEF3C7', text: '#92400E', dot: '#F59E0B' },
  active:    { bg: '#DBEAFE', text: '#1E40AF', dot: '#3B82F6' },
  returned:  { bg: '#DCFCE7', text: '#166534', dot: '#22C55E' },
  cancelled: { bg: '#F1F5F9', text: '#64748B', dot: '#94A3B8' },
}

export const lossCategoryConfig = {
  unpaid_rental: { label: 'Unpaid Rental', bg: 'bg-red-100',    text: 'text-red-800'    },
  accident:      { label: 'Accident',       bg: 'bg-orange-100', text: 'text-orange-800' },
  damage:        { label: 'Damage',         bg: 'bg-yellow-100', text: 'text-yellow-800' },
  theft:         { label: 'Theft',          bg: 'bg-purple-100', text: 'text-purple-800' },
  maintenance:   { label: 'Maintenance',    bg: 'bg-blue-100',   text: 'text-blue-800'   },
  other:         { label: 'Other',          bg: 'bg-gray-100',   text: 'text-gray-600'   },
}
